import { render, staticRenderFns } from "./introduce-tabs.vue?vue&type=template&id=76f4068c&scoped=true"
import script from "./introduce-tabs.vue?vue&type=script&lang=js"
export * from "./introduce-tabs.vue?vue&type=script&lang=js"
import style0 from "./introduce-tabs.vue?vue&type=style&index=0&id=76f4068c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_j7fuxwmg3pjjrof4ryv5g7uhre/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f4068c",
  null
  
)

export default component.exports